import {
  IApplicationState,
  IReducerWarningOverlay,
  OVERLAY_WARNING_NOTIFICATION_SET_CONTENT,
  OVERLAY_WARNING_NOTIFICATION_SHOW,
  updateUserSession,
} from '@spinwise/spinwise-core';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { messages, subscriber } from '../../../utils/observable';
import { Trans } from 'react-i18next';
import { BrandIcons, ShapeColors, StatusIcons } from '../BrandIcon/BrandIcon';
import { EWarningOverlayTypes } from '../Overlay/elements/WarningOverlayManager/WarningOverlayManagerComponent';
import { t } from 'i18next';
import { filter } from 'rxjs';
import { logoutChannel } from 'src/channels/logout.channel';

export enum ESessionLimitOptions {
  'TAKE_BREAK' = 'take_break',
  'CONTINUE' = 'continue',
}

const SessionLimit = () => {
  const limit = useSelector(
    (state: IApplicationState) => state.accountReducer?.info?.isSessionLimitEnabled?.limit || 0,
  );
  const sessionLimitReached = useSelector(
    (state: IApplicationState) => state.accountReducer?.info?.sessionLimitReached || false,
  );
  const isLoggedIn = useSelector((state: IApplicationState) => state.authReducer?.auth?.success);
  const dispatch = useDispatch();
  const [popupShown, SetPopupShown] = useState(false);

  const openBreakPopup = useCallback(() => {
    const contentData: IReducerWarningOverlay = {
      headerTitle: t('session.limit.overlay.header.title'),
      icon: BrandIcons.Break,
      status: StatusIcons.None,
      type: EWarningOverlayTypes.Default,
      shapeColor: ShapeColors.Default,
      title: t('session.limit.overlay.title'),
      subtitle: (
        <Trans components={{ MINUTES: limit }} transKeepBasicHtmlNodesFor>
          {'session.limit.overlay.description'}
        </Trans>
      ) as unknown as string,
      btnAcceptText: t('session.limit.overlay.accept.btn'),
      btnDeniedText: t('session.limit.overlay.deny.btn'),
    };

    dispatch({
      type: OVERLAY_WARNING_NOTIFICATION_SET_CONTENT,
      data: contentData,
    });
    dispatch({
      type: OVERLAY_WARNING_NOTIFICATION_SHOW,
      data: true,
    });
    messages.send({
      target: 'session-limit',
      primary: null,
    });

    SetPopupShown(true);
  }, [limit]);

  const handleOverlayResponse = ({ primary }) => {
    dispatch({
      type: OVERLAY_WARNING_NOTIFICATION_SHOW,
      data: false,
    });

    updateUserSession({ action: primary ? ESessionLimitOptions.CONTINUE : ESessionLimitOptions.TAKE_BREAK })(dispatch);
    messages.clear();

    const didTakeBreak = !primary;
    if (didTakeBreak) logoutChannel.send({ action: 'logout_start', logoutStart: true, loaded: true });
  };

  useEffect(() => {
    const limitOverlayResponse = subscriber.pipe(
      filter(({ target, primary }) => target === 'session-limit' && primary !== null),
    );

    const sub = limitOverlayResponse.subscribe(handleOverlayResponse);

    return () => sub.unsubscribe();
  }, []);

  useEffect(() => {
    if (!sessionLimitReached) return SetPopupShown(false);
    if (popupShown || !isLoggedIn) return;

    openBreakPopup();
  }, [sessionLimitReached, openBreakPopup, popupShown, isLoggedIn]);

  return <></>;
};

export default SessionLimit;
